<template>
  <div id="index">
    <div class="visible-xs min_index">
      <header class="flex_center m_header">
        <i class="esc" @click="goBackward"><img src="@/assets/img/esc_fan.png" alt="" /></i>
        <h4 class="header_title">麻醉眼界</h4>
      </header>
      <div class="p30">
        <div class="title">基本信息 <span class="f_title">（请正确填写信息）</span></div>
        <div class="flex_start flex_items mb20">
          <div class="jb_title"><span>姓名</span>:</div>
          <input type="text" class="jb_input" maxlength="20" v-model="name" />
        </div>
        <div class="flex_start flex_items mb20">
          <div class="jb_title"><span>手机号</span>:</div>
          <input type="number" class="jb_input" maxlength="11"  oninput="if(value.length>11)value=value.slice(0,11)" v-model="mobile" />
        </div>
        <div class="flex_start flex_items">
          <div class="jb_title"><span>医院</span>:</div>
          <input type="text" class="jb_input" maxlength="50" v-model="hospital" />
        </div>
      </div>

      <div class="div_li p30">
        <h5 class="title">上传图片作品</h5>
        <div class="img_div form_div flex_start">
          <i class="img_li flex_center" v-for="(liem, index) in image" :key="index">
            <div class="flex_center img_li_div li_r_img">
              <img :src="liem" alt="" />
            </div>
            <i class="end_icon" @click="endFun(index)"><img src="@/assets/img/shutDown.png" alt="" /></i>
          </i>
          <i class="up_img img_li" v-if="image.length < 4" @click="upImgFun">
            <input type="file" class="inp_img" @change="handleChange" id="imgInp" ref="inputer" multiple
              accept="image/*" />
            <img src="@/assets/img/add_icon.jpg" alt="" /></i>
        </div>
        <div class="zhu">注：第一张为封面图，最多上传4张图片，每张小于10M</div>
      </div>
      <div class="p30">
        <div class="title">描述</div>
        <div class="flex_start flex_items">
          <div class="jb_title"><span>标题</span>:</div>
          <input type="text" maxlength="50" v-model="title" class="jb_input" />
        </div>
        <textarea placeholder="添加描述..." maxlength="200" v-model="content"></textarea>
        <div class="flex_end">
          <div class="btn" @click="submit">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import "@/assets/js/currency.js";
  export default {
    name: "index",
    data() {
      return {
        id: 0,
        name: "",
        mobile: "",
        hospital: "",
        title: "",
        content: "",
        image: [],

        is_app: this.$store.state.is_app,
      };
    },
    computed: {},
    components: {},
    props: {},
    watch: {},
    methods: {
      // 判断
      judge() {
        if (this.name == "" || !this.name) {
          layer.open({
            content: "请输入姓名!",
            time: true,
            skin: "msg",
          });
          return false;
        }
        if (this.mobile == "" || !this.mobile) {
          layer.open({
            content: "请输入手机号!",
            time: true,
            skin: "msg",
          });
          return false;
        }
        if (this.hospital == "" || !this.hospital) {
          layer.open({
            content: "请输入医院名称!",
            time: true,
            skin: "msg",
          });
          return false;
        }
        if (this.image.length <= 0 || !this.image) {
          layer.open({
            content: "请上传作品图片!",
            time: true,
            skin: "msg",
          });
          return false;
        }
        if (this.title == "" || !this.title) {
          layer.open({
            content: "请输入标题!",
            time: true,
            skin: "msg",
          });
          return false;
        }
        if (this.content == "" || !this.content) {
          layer.open({
            content: "请输入描述!",
            time: true,
            skin: "msg",
          });
          return false;
        }
        return true;
      },
      //   提交作品
      submit() {
        if (!this.judge()) {
          return false;
        }
        let that = this;
        let data = {
          name: this.name,
          mobile: this.mobile,
          hospital: this.hospital,
          title: this.title,
          content: this.content,
          image: this.image.join(","),
          member_id: this.USER().id,
        };
         

        var layerOpen = layer.open({
          type: 2,
          content: "提交中。。。",
        });

        this.$post("activity-add", data)
          .then((res) => {
            layer.close(layerOpen);
            layer.open({
              content: res.msg,
              time: 1.5,
              skin: "msg",
            });
            setTimeout(() => {
              that.goBackward();
            }, 1500)
          })
          .catch((error) => {
            layer.close(layerOpen);
            layer.open({
              content: error.message,
              time: 2,
              skin: "msg",
            });
          });
      },
      upImgFun() {
         
        if (this.is_app) {
          let that = this;
          let index = layer.open({
            title: [
              '选择方式',
              'background-color: #FF4351; color:#fff;'
            ]
            , content: '<div id="session" style="width: 60%;height: 4rem;border-radius: .6rem;margin: 1rem auto;line-height: 4rem; background: #1AAD19;color:#fff;">拍照</div>' +
              '<div id="circle"  style="width: 60%;height: 4rem;border-radius: .6rem;margin: 1rem auto;line-height: 4rem; background: #1AAD19;color:#fff;">相册</div>'
          });
          $('#session').click(() => {//拍照
            android.pictureMethod(1);
            layer.close(index);
          })
          $('#circle').click(() => {//相册
            android.pictureMethod(2);
            layer.close(index);
          })
        }
      },
      getDetails() {
        //获取详情
        let that = this;
        this.$post("index-view", { id: this.id }).then((res) => {
          that.activity = res.data;
          that.getShare(that.activity.title, that.activity.cover ? that.details.cover : '');
        });
      },
      //删除图片
      endFun(index) {
        this.image.splice(index, 1);
      },
      upImg(img) {
        this.image.push(result.data);
      },
      //   上传图片
      handleChange(e) {
        let that = this;
        let images = "";
        var reader = new FormData();
        reader.append("file", e.target.files[0]);
        var layerOpen = layer.open({
          type: 2,
          content: "上传中。。。",
        });

        //发送图片消息
        $.ajax({
          type: "POST", //提交方式
          url: this.$URL + "upload", //路径
          data: reader,
          processData: false,
          contentType: false,
          success: function (result) {
            //返回数据根据结果进行相应的处理
            layer.close(layerOpen);
            if (result.data) {
              that.image.push(result.data);

              that.$nextTick(() => {
                that.addImg();
              });
            }
          },
        });
      },
      addImg() {
        $(".li_r_img img").on("click", function () {
           
          $(this).ImgZoomIn("");
        });
      },
      goBackward() {
        //返回上一页
        if (window.history.length > 2) {
          this.$router.go(-1);
        } else {
          this.$router.replace("/m_home");
        }
      },
    },
    created() { },
    mounted() {
      this.id = this.$route.query.id;
      window.upImg = this.upImg;
      this.getDetails();
      if(this.USER()){//用户数据赋值
        this.name = this.USER().realname?this.USER().realname:'';
        this.mobile = this.USER().mobile?this.USER().mobile:'';
        this.hospital = this.USER().company?this.USER().company:'';
      }
      if (this._isMobile()) {

      } else {
        // alert("pc端");
        this.$router.push({ path: '/pc_activity', query: { id: this.id } });
      }
    },
  };
</script>
<style>
</style>
<style scoped>
  .p30 {
    padding: 0 2rem;
  }

  input {
    padding: 0 0 0 0.6rem;
  }

  .title {
    font-size: 1.8rem;
    color: #2b2b2b;
    font-weight: bold;
    margin: 2.5rem 0;
  }
  .title .f_title{
    font-size: 1.4rem;
    color:#666;
    margin-left: .4rem;
    font-weight: normal;
  }

  .jb_title {
    width: 5rem;
    font-size: 1.5rem;
    color: #888;
    margin-right: 3rem;
  }

  .jb_title span {
    display: inline-block;
    text-align-last: justify;
    width: 4.5rem;
  }

  .jb_input {
    /* width: 33.7rem; */
    flex: 1;
    height: 2.7rem;
    border: solid 0.075rem #a0a0a0;
  }

  .mb20 {
    margin-bottom: 2rem;
  }


  .zhu {
    font-size: 1.5rem;
    color: #888;
    margin-top: 1.4rem;
  }

  textarea {
    width: calc(100% - 1.15rem);
    height: 19rem;
    border: solid 0.075rem #a0a0a0;
    padding-left: 1rem;
    padding-top: 1rem;
    margin-top: 2rem;
  }

  .btn {
    width: 11.4rem;
    line-height: 3.6rem;
    background: #e0595f;
    border-radius: 0.5rem;
    text-align: center;
    margin-top: 5rem;
    color: #fff;
    font-size: 1.6rem;
    margin-right: 2rem;
  }

  .fh_btn {
    width: 11.4rem;
    line-height: 3.6rem;
    border: solid 0.05rem #999;
    border-radius: 0.5rem;
    text-align: center;
    margin-top: 5rem;
    font-size: 1.6rem;
  }

  .div_li {
    width: 100%;
  }

  .img_div {
    width: calc(100% - 40px);
    transform: translateX(-10px);
  }

  .img_div>.img_li {
    width: calc(25% - 1.4rem);
    display: inline-flex;
    margin: 0 .7rem;

    position: relative;
  }

  .img_div>.img_li .img_li_div {
    width: 100%;
    max-height: 9rem;
    overflow: hidden;
  }

  .img_div>.img_li .img_li_div img {
    width: 100%;
  }

  .img_div>.img_li .end_icon {
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(50%, -50%);
    width: 2rem;
    height: 2rem;
    cursor: pointer;
  }

  .img_div>.img_li>input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: inline-block;
    width: 100%;
    padding: 0;
    bottom: 0;
    opacity: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/minActivity/m_activityForm.vue